import { Component, inject } from '@angular/core';
import { Language, TranslatorService } from '@services/translator/translator.service';


import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
    selector: 'app-language-switch',
    templateUrl: './language-switch.component.html',
    styles: [],
    standalone: true,
    imports: [BsDropdownModule, TranslateModule, TooltipModule]
})
export class LanguageSwitchComponent {
    protected readonly translator = inject(TranslatorService);
    readonly availableLanguages: Language[];
    selectedLanguage: Language;

    constructor(
) {
        this.selectedLanguage = this.translator.currentLanguage;
        this.availableLanguages = this.translator.availableLanguages;
    }

    setLanguage(language: Language) {
        this.translator.setLanguage(language).then(res => {
            this.translator.currentLanguage = res;
            this.selectedLanguage = this.translator.currentLanguage;
        });
    }
}
